import {
  createRoute,
  lazyRouteComponent,
  useParams,
  useSearch,
} from '@tanstack/react-router'

import type { CasinoSearch } from '../../types/route-search'
import { casinoRoute } from '.'

const Casino = lazyRouteComponent(() => import('../../pages/casino'))

const CasinoCategoryPage = () => {
  const { category } = useParams({ from: '/casino/$category' })
  const search = useSearch({ from: '/casino/$category' })
  return <Casino category={category} {...search} />
}

export const casinoCategoryRoute = createRoute({
  getParentRoute: () => casinoRoute,
  path: '$category',
  component: CasinoCategoryPage,
  validateSearch: (search: Record<string, unknown>): CasinoSearch => {
    return {
      platform: typeof search.platform === 'string' ? search.platform : '',
      error: typeof search.error === 'string' ? search.error : '',
      message: typeof search.message === 'string' ? search.message : '',
      reg: typeof search.reg === 'string' ? search.reg : '',
    }
  },
})
